import React from 'react';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { CheckBoxProps } from './Types';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

const CheckBox: React.FC<CheckBoxProps> = ({
  label = '',
  checked = false,
  onClick,
  name,
  disabled,
}) => {
  const { dir } = useCommonSelector((state) => state.common.settings);

  return (
    <div>
      <label className="inline-flex items-center ">
        <input
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onClick && onClick(event.currentTarget.checked)
          }
          type="checkbox"
          name={name}
          checked={checked || false}
          disabled={disabled}
          className={`input form-checkbox focus:ring-4 ${
            !disabled && 'cursor-pointer'
          } focus:ring-ring-color focus:ring-opacity-10 focus:ring-offset-0 focus:shadow-md  rounded-sm text-primary`}
        ></input>
        <span
          className={`ms-2 text-base ${
            dir === 'rtl' && 'text-right'
          } text-gray-700`}
        >
          <ReturnTranslatedText
            text={`inputs.labels.${label}`}
            origintext={label as string}
          />
        </span>
      </label>
    </div>
  );
};

export default CheckBox;
